import comp from "./SelectAttachmentComponent";
export default comp;
